import React, { Component } from "react";
import Helmet from "react-helmet";
import Layout from "../../../layout";
import config from "../../../../data/SiteConfig";


class FollwingPage extends Component {
  render() {
    return (
        <Layout location={this.props.location} title="About">
        <div className="Page-alignment wide-page">
          <Helmet>
            <title>{config.siteTitle}</title>
            <link rel="canonical" href={`${config.siteUrl}${config.pathPrefix}/security-is-not-a-product-but-a-process/attachment/following`} />
          </Helmet>
          <article className="Article fade-in Article--fix jCenter">
            <div className="Article-header">
              <iframe 
                  title="This is a unique title" 
                  src="https://kevinmiston.github.io/report-visualization/page-02.html" 
                  frameBorder="0"
                  style={{width:100 + 'vw'}}
                 
                  height="800"
                  scrolling="no"
                  allowFullScreen />
               
            </div>
          </article>
        </div>
      </Layout>
      )
  }
}

export default FollwingPage;
